var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"navigation__item"},[_c('router-link',{attrs:{"to":{ name: _vm.route }}},[_c('Button',{class:['navigation__button', { 'active': _vm.hasActiveClass(_vm.route) }],attrs:{"icon":`icon icon-${_vm.icon}`,"type":"text","is-navbar-button":""}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }